import { z } from "zod";

import { system } from "@smart/bridge-types-basic";
import { buildSNSSQSDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const DeadLetterAnalyserNS = buildNamespace({
  system,
  entity: "DeadLetterAnalyser",
} as const);

export const DeadLetterAnalyserSchema = z.object({
  deadLetterId: z.string(),
  channelId: z.string(),
  messageTs: z.string(),
  system: z.string(),
  entity: z.string(),
  deadAt: z.string(),
  sentAt: z.string(),
  content: z.any(),
});

const deadLetterAnalyserGuard = wrapSchema(DeadLetterAnalyserSchema);

export const DeadLetterAnalyserDef = buildSNSSQSDef({
  namespace: DeadLetterAnalyserNS,
  guard: deadLetterAnalyserGuard,
  sqsOnly: false,
  groupKey: "system",
  idKey: "deadLetterId",
});
